import { Component } from '@angular/core';

import { InlineSvgComponent } from '@instaclause-webapp/shared-ui';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-support-banner',
  imports: [ TranslocoModule, InlineSvgComponent ],
  templateUrl: './support-banner.component.html',
  styleUrl: './support-banner.component.scss',
})
export class SupportBannerComponent {}
